module.exports = __webpack_public_path__ + "static/media/嵩山少林景区-min.3f2644a8.jpg";